import React, { useState } from 'react';
import { 
  LaptopOutlined, RobotOutlined, MessageOutlined, SettingOutlined, 
  AimOutlined, NotificationOutlined, UserOutlined, BarsOutlined, TeamOutlined, CommentOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  WhatsAppOutlined, ReadOutlined
} from '@ant-design/icons';

import { 
  Button,
  Breadcrumb, Layout, Menu, theme,
  Col, Row,
  Collapse, Divider
} from 'antd';
import { useNavigate, Navigate } from "react-router-dom";

const { Header, Content, Sider, Footer } = Layout;

const items1 = ['1', '2', '3', '4'].map((key) => {
  if(key === '1') {
    return {
      key,
      label: `Profile`,
    }
  } else if(key === '2') {
    return {
      key,
      label: `Help`,
    }
  } else if(key === '3') {
    return {
      key,
      label: `Others`,
    }
  }
});

const items2 = [BarsOutlined, RobotOutlined, MessageOutlined, SettingOutlined, AimOutlined, TeamOutlined].map((icon, index) => {
  const key = String(index);
  if (key == 0) {
    return {
      key: `dashboard`,
      icon: React.createElement(icon),
      label: `Dasboard`,
    };
  } else if (key == 1) {
    return {
      key: `bot`,
      icon: React.createElement(icon),
      label: `Your bots`,
    };
  } else if (key == 2) {
    return {
      key: `chat`,
      icon: React.createElement(icon),
      label: `Chats`,
      children: ["Whatsapp", "Facebook", "Instagram", "Telegram"].map((chat, j) => {
        return {
          key: chat,
          label: chat,
        };
      }),
    };
  } else if (key == 3) {
    return {
      key: `setting`,
      icon: React.createElement(icon),
      label: `Settings`,
    };
  } else if (key == 4) {
    return {
      key: `ai`,
      icon: React.createElement(icon),
      label: `AI`,
      children: ["Chat with AI", "Train document", "How-to-AI"].map((chat, j) => {
        return {
          key: chat,
          label: chat,
        };
      }),
    };
  } else if (key == 5) {
    return {
      key: `users`,
      icon: React.createElement(icon),
      label: `Users`,
    };
  }
});

const App = () => {
  
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  const handleClick = () => {
      navigate("/");
  }

  return (
    <Layout style={{
      height: '100vh'
    }}>
      <Sider trigger={null} collapsible collapsed={collapsed}
          theme="dark"
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(broken) => {
            console.log(broken);
          }}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
          style={{
            overflow: 'auto',
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
          <button 
            style={{
              width: '100%',
              borderRight: 0,
              background: 'none',
              textAlign: 'left',
              padding: 10,
              border: 'none',
              color: 'white'
            }}>
              <h1><UserOutlined /> Mwfartech</h1>
          </button>
          <Menu
            mode="inline"
            theme="dark"
            defaultSelectedKeys={['dashboard']}
            defaultOpenKeys={['dashboard']}
            style={{
              borderRight: 0,
            }}
            items={items2}
          />
      </Sider>
      <Layout>
          <Header
              style={{
                padding: 0,
                background: colorBgContainer,
              }}
          >
            <Row>
              <Col span={2}>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                  }}
                />
              </Col>
              <Col span={2} offset={20}>
                <Button type="primary" onClick={handleClick}> Logout </Button>
              </Col>
            </Row>
          </Header>
          <Content
            style={{
              margin: '24px 16px 0',
            }}
          >
            <div
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                height: '100%'
              }}
            >
            <Divider orientation="left">Your accounts</Divider>
            <Row justify="center">
              <Col span={24}>
                <Collapse
                  size="default"
                  items={[
                    {
                      key: '1',
                      label: "Facebook",
                      children: 
                        <Row>
                          <Col span={8}><h3>Total Visits: 100k</h3></Col>
                          <Col span={8}><h3>Bots interaction: 820</h3></Col>
                          <Col span={8}><h3>Comments interaction: 2.5k</h3></Col>
                        </Row>,
                    },
                  ]}
                />
              </Col>
            </Row>
            <Divider orientation="left"></Divider>
            <Row  justify="space-between">
              <Col span={8}>
                <Collapse
                  size="default"
                  items={[
                    {
                      key: '2',
                      label: "Instagram",
                      children: 
                          <>
                            <h3><TeamOutlined /> Total Visits: 100k</h3>
                            <h3><RobotOutlined /> Bots interaction: 820</h3>
                            <h3><CommentOutlined /> Comments interaction: 2.5k</h3>
                          </>
                    },
                  ]}
                />
              </Col>
              
              <Col span={8}>
                <Collapse
                  
                  size="default"
                  items={[
                    {
                      key: '2',
                      label: "Whatsapp",
                      children: 
                        <>
                          <button type="primary" >
                            <h3><WhatsAppOutlined /> Get your Whatsapp Bot now !</h3>
                          </button>
                        </>
                    },
                  ]}
                />
              </Col>
              <Col span={6} >
                <button type="primary">
                  <h3> <ReadOutlined /> Read our documentation !</h3>
                </button>
              </Col>
            </Row>
            <Divider orientation="left">Charts</Divider>
            </div>
          </Content>
          
          <Footer style={{ textAlign: 'center' }}>
            FAR Tech ©{new Date().getFullYear()} Created by FAR Tech
          </Footer>
        </Layout>
    </Layout>
  );
};
export default App;
